// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailed-event .subtitle[data-v-4005b6a6] {\n  margin-bottom: 7px;\n}", ""]);
// Exports
module.exports = exports;
